import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  advertisement: "",
};

const AdsCampaignReducer = createSlice({
  name: "AdsCampaignReducer",
  initialState: initialState,
  reducers: {
    setNewAdvertisement: (state, { payload }) => {
      console.log({ payload });
      return {
        ...state,
        advertisement: payload,
      };
    },

    clearedNewAdvertisement: (state) => {
      return {
        ...state,
        advertisement: "",
      };
    },
  },
});
export default AdsCampaignReducer;
